<div
  tabindex="0"
  class="max-h-[80vh] w-full sm:w-[400px]"
  (click)="$event.stopPropagation()">
  @let ticket = data.ticket;
  <aw-ticket-tile
    id="ticket-information-dialog"
    (onButtonClick)="dialogRef.close()"
    [buttonTextOverride]="
      textStore.texts()
        | filterTexts: ERelationType.close : EEntityType.generic
        | language
    "
    [ticket]="ticket | toTicketTile: data.name"></aw-ticket-tile>
</div>
